// Generated by scripts/write-one-night-ultimate-werewolf-replay-fixtures.ts.
// Do not edit manually.

import type { OneNightReplayEventType } from "./event-adapter";

export interface OneNightReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface OneNightReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: OneNightReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface OneNightReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "one-night-ultimate-werewolf";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly observerUserId: string;
  readonly players: readonly OneNightReplayFixturePlayer[];
  readonly events: readonly OneNightReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const ONE_NIGHT_ULTIMATE_WEREWOLF_REPLAY_FIXTURES: Record<
  string,
  OneNightReplayFixture
> = {
  "full-game-6p": {
    schemaVersion: 1,
    gameType: "one-night-ultimate-werewolf",
    scenario: "full-game-6p",
    source: "generated",
    capturedAt: "2026-10-21T00:00:00.000Z",
    observerUserId: "observer",
    players: [
      {
        id: "p1",
        name: "보라",
        role: "host",
      },
      {
        id: "p2",
        name: "찬",
        role: "player",
      },
      {
        id: "p3",
        name: "준호",
        role: "player",
      },
      {
        id: "p4",
        name: "도윤",
        role: "player",
      },
      {
        id: "p5",
        name: "은서",
        role: "player",
      },
      {
        id: "p6",
        name: "아리",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "one-night-ultimate-werewolf-replay-full-game-6p",
            seed: "onuw-replay-full-game-6p-seed-17",
            createdAt: "2026-10-21T00:00:00.000Z",
            version: 0,
            phase: "setup",
            hostPlayerId: "p1",
            players: [
              {
                id: "p1",
                name: "보라",
                seatNumber: 1,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p2",
                name: "찬",
                seatNumber: 2,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p3",
                name: "준호",
                seatNumber: 3,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p4",
                name: "도윤",
                seatNumber: 4,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p5",
                name: "은서",
                seatNumber: 5,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p6",
                name: "아리",
                seatNumber: 6,
                startingCardId: null,
                voteTargetId: null,
              },
            ],
            seatOrder: ["p1", "p2", "p3", "p4", "p5", "p6"],
            seatLocked: false,
            selectedRoleIds: [],
            cards: [],
            cardPositions: {},
            centerSlots: [null, null, null],
            privateKnowledge: {},
            doppelgangerCopiedRoleId: null,
            rolePeekConfirmedPlayerIds: [],
            nightRoleQueue: [],
            announcerTimeline: [],
            nightLog: [],
            discussionDurationSeconds: 300,
            discussionRemainingSeconds: null,
            voteWindowSeconds: 10,
            voteRemainingSeconds: null,
            autoVotePlayerIds: [],
            voteResult: null,
            revealedCardIds: [],
            gameOutcome: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SyncViewerState",
        userId: "p1",
        payload: {
          actionId: "full-game-6p:sync-initial-view",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "selectRoles",
            actorPlayerId: "p1",
            roleIds: [
              "werewolf",
              "werewolf",
              "minion",
              "mason",
              "mason",
              "seer",
              "robber",
              "troublemaker",
              "drunk",
            ],
          },
        },
      },
      {
        sequenceNumber: 4,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "setDiscussionDuration",
            actorPlayerId: "p1",
            durationSeconds: 180,
          },
        },
      },
      {
        sequenceNumber: 5,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "lockSeatOrder",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 6,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "dealCards",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 7,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 8,
        eventType: "action",
        userId: "p2",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p2",
          },
        },
      },
      {
        sequenceNumber: 9,
        eventType: "action",
        userId: "p3",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p3",
          },
        },
      },
      {
        sequenceNumber: 10,
        eventType: "action",
        userId: "p4",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p4",
          },
        },
      },
      {
        sequenceNumber: 11,
        eventType: "action",
        userId: "p5",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p5",
          },
        },
      },
      {
        sequenceNumber: 12,
        eventType: "action",
        userId: "p6",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p6",
          },
        },
      },
      {
        sequenceNumber: 13,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "startNight",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 14,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "werewolf",
          },
        },
      },
      {
        sequenceNumber: 15,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p1",
            roleId: "werewolf",
            payload: {
              kind: "confirmNoAction",
            },
          },
        },
      },
      {
        sequenceNumber: 16,
        eventType: "action",
        userId: "p4",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p4",
            roleId: "werewolf",
            payload: {
              kind: "confirmNoAction",
            },
          },
        },
      },
      {
        sequenceNumber: 17,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "minion",
          },
        },
      },
      {
        sequenceNumber: 18,
        eventType: "action",
        userId: "p5",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p5",
            roleId: "minion",
            payload: {
              kind: "minionSeeWerewolves",
            },
          },
        },
      },
      {
        sequenceNumber: 19,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "mason",
          },
        },
      },
      {
        sequenceNumber: 20,
        eventType: "action",
        userId: "p2",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p2",
            roleId: "mason",
            payload: {
              kind: "masonSeeMasons",
            },
          },
        },
      },
      {
        sequenceNumber: 21,
        eventType: "action",
        userId: "p6",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p6",
            roleId: "mason",
            payload: {
              kind: "masonSeeMasons",
            },
          },
        },
      },
      {
        sequenceNumber: 22,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "seer",
          },
        },
      },
      {
        sequenceNumber: 23,
        eventType: "action",
        userId: "p3",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p3",
            roleId: "seer",
            payload: {
              kind: "seerInspectPlayer",
              targetPlayerId: "p1",
            },
          },
        },
      },
      {
        sequenceNumber: 24,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "robber",
          },
        },
      },
      {
        sequenceNumber: 25,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "troublemaker",
          },
        },
      },
      {
        sequenceNumber: 26,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "drunk",
          },
        },
      },
      {
        sequenceNumber: 27,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "tickDiscussion",
            actorPlayerId: "p1",
            elapsedSeconds: 180,
          },
        },
      },
      {
        sequenceNumber: 28,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p1",
            targetPlayerId: "p2",
          },
        },
      },
      {
        sequenceNumber: 29,
        eventType: "action",
        userId: "p2",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p2",
            targetPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 30,
        eventType: "action",
        userId: "p3",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p3",
            targetPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 31,
        eventType: "action",
        userId: "p4",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p4",
            targetPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 32,
        eventType: "action",
        userId: "p5",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p5",
            targetPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 33,
        eventType: "action",
        userId: "p6",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p6",
            targetPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 34,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "resolveVote",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 35,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p1",
            },
          },
        },
      },
      {
        sequenceNumber: 36,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p2",
            },
          },
        },
      },
      {
        sequenceNumber: 37,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p3",
            },
          },
        },
      },
      {
        sequenceNumber: 38,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p4",
            },
          },
        },
      },
      {
        sequenceNumber: 39,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p5",
            },
          },
        },
      },
      {
        sequenceNumber: 40,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p6",
            },
          },
        },
      },
      {
        sequenceNumber: 41,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "center",
              slotIndex: 0,
            },
          },
        },
      },
      {
        sequenceNumber: 42,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "center",
              slotIndex: 1,
            },
          },
        },
      },
      {
        sequenceNumber: 43,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "center",
              slotIndex: 2,
            },
          },
        },
      },
      {
        sequenceNumber: 44,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "completeRound",
            actorPlayerId: "p1",
          },
        },
      },
    ],
    notes: [
      "Deterministic self-play: every action was validated by the engine before being recorded.",
      "Hidden-info contract: the replay UI renders the masked observer projection by default; player perspectives and the recap toggle are explicit opt-ins.",
      "Final outcome: werewolf-eliminated.",
      "Role pool exercises werewolf pair, minion, mason pair, seer, robber, troublemaker, and drunk.",
    ],
  },
  "doppelganger-6p": {
    schemaVersion: 1,
    gameType: "one-night-ultimate-werewolf",
    scenario: "doppelganger-6p",
    source: "generated",
    capturedAt: "2026-10-21T00:00:00.000Z",
    observerUserId: "observer",
    players: [
      {
        id: "p1",
        name: "보라",
        role: "host",
      },
      {
        id: "p2",
        name: "찬",
        role: "player",
      },
      {
        id: "p3",
        name: "준호",
        role: "player",
      },
      {
        id: "p4",
        name: "도윤",
        role: "player",
      },
      {
        id: "p5",
        name: "은서",
        role: "player",
      },
      {
        id: "p6",
        name: "아리",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "one-night-ultimate-werewolf-replay-doppelganger-6p",
            seed: "onuw-replay-doppelganger-6p-seed-1",
            createdAt: "2026-10-21T00:00:00.000Z",
            version: 0,
            phase: "setup",
            hostPlayerId: "p1",
            players: [
              {
                id: "p1",
                name: "보라",
                seatNumber: 1,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p2",
                name: "찬",
                seatNumber: 2,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p3",
                name: "준호",
                seatNumber: 3,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p4",
                name: "도윤",
                seatNumber: 4,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p5",
                name: "은서",
                seatNumber: 5,
                startingCardId: null,
                voteTargetId: null,
              },
              {
                id: "p6",
                name: "아리",
                seatNumber: 6,
                startingCardId: null,
                voteTargetId: null,
              },
            ],
            seatOrder: ["p1", "p2", "p3", "p4", "p5", "p6"],
            seatLocked: false,
            selectedRoleIds: [],
            cards: [],
            cardPositions: {},
            centerSlots: [null, null, null],
            privateKnowledge: {},
            doppelgangerCopiedRoleId: null,
            rolePeekConfirmedPlayerIds: [],
            nightRoleQueue: [],
            announcerTimeline: [],
            nightLog: [],
            discussionDurationSeconds: 300,
            discussionRemainingSeconds: null,
            voteWindowSeconds: 10,
            voteRemainingSeconds: null,
            autoVotePlayerIds: [],
            voteResult: null,
            revealedCardIds: [],
            gameOutcome: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SyncViewerState",
        userId: "p1",
        payload: {
          actionId: "doppelganger-6p:sync-initial-view",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "selectRoles",
            actorPlayerId: "p1",
            roleIds: [
              "werewolf",
              "werewolf",
              "doppelganger",
              "mason",
              "mason",
              "seer",
              "robber",
              "troublemaker",
              "drunk",
            ],
          },
        },
      },
      {
        sequenceNumber: 4,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "setDiscussionDuration",
            actorPlayerId: "p1",
            durationSeconds: 180,
          },
        },
      },
      {
        sequenceNumber: 5,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "lockSeatOrder",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 6,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "dealCards",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 7,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 8,
        eventType: "action",
        userId: "p2",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p2",
          },
        },
      },
      {
        sequenceNumber: 9,
        eventType: "action",
        userId: "p3",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p3",
          },
        },
      },
      {
        sequenceNumber: 10,
        eventType: "action",
        userId: "p4",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p4",
          },
        },
      },
      {
        sequenceNumber: 11,
        eventType: "action",
        userId: "p5",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p5",
          },
        },
      },
      {
        sequenceNumber: 12,
        eventType: "action",
        userId: "p6",
        payload: {
          schemaVersion: 1,
          action: {
            type: "confirmRolePeek",
            actorPlayerId: "p6",
          },
        },
      },
      {
        sequenceNumber: 13,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "startNight",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 14,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "doppelganger",
          },
        },
      },
      {
        sequenceNumber: 15,
        eventType: "action",
        userId: "p6",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p6",
            roleId: "doppelganger",
            payload: {
              kind: "doppelgangerCopy",
              targetPlayerId: "p1",
            },
          },
        },
      },
      {
        sequenceNumber: 16,
        eventType: "action",
        userId: "p6",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p6",
            roleId: "doppelganger",
            payload: {
              kind: "robberSwap",
              targetPlayerId: "p1",
            },
          },
        },
      },
      {
        sequenceNumber: 17,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "werewolf",
          },
        },
      },
      {
        sequenceNumber: 18,
        eventType: "action",
        userId: "p2",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p2",
            roleId: "werewolf",
            payload: {
              kind: "werewolfPeekCenter",
              centerSlotIndex: 0,
            },
          },
        },
      },
      {
        sequenceNumber: 19,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "mason",
          },
        },
      },
      {
        sequenceNumber: 20,
        eventType: "action",
        userId: "p3",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p3",
            roleId: "mason",
            payload: {
              kind: "masonSeeMasons",
            },
          },
        },
      },
      {
        sequenceNumber: 21,
        eventType: "action",
        userId: "p4",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p4",
            roleId: "mason",
            payload: {
              kind: "masonSeeMasons",
            },
          },
        },
      },
      {
        sequenceNumber: 22,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "seer",
          },
        },
      },
      {
        sequenceNumber: 23,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "robber",
          },
        },
      },
      {
        sequenceNumber: 24,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p1",
            roleId: "robber",
            payload: {
              kind: "robberSwap",
              targetPlayerId: "p2",
            },
          },
        },
      },
      {
        sequenceNumber: 25,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "troublemaker",
          },
        },
      },
      {
        sequenceNumber: 26,
        eventType: "action",
        userId: "p5",
        payload: {
          schemaVersion: 1,
          action: {
            type: "submitNightAction",
            actorPlayerId: "p5",
            roleId: "troublemaker",
            payload: {
              kind: "troublemakerSwap",
              targetPlayerIds: ["p1", "p2"],
            },
          },
        },
      },
      {
        sequenceNumber: 27,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "advanceAnnouncement",
            actorPlayerId: "p1",
            roleId: "drunk",
          },
        },
      },
      {
        sequenceNumber: 28,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "tickDiscussion",
            actorPlayerId: "p1",
            elapsedSeconds: 180,
          },
        },
      },
      {
        sequenceNumber: 29,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p1",
            targetPlayerId: "p2",
          },
        },
      },
      {
        sequenceNumber: 30,
        eventType: "action",
        userId: "p2",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p2",
            targetPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 31,
        eventType: "action",
        userId: "p3",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p3",
            targetPlayerId: "p2",
          },
        },
      },
      {
        sequenceNumber: 32,
        eventType: "action",
        userId: "p4",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p4",
            targetPlayerId: "p2",
          },
        },
      },
      {
        sequenceNumber: 33,
        eventType: "action",
        userId: "p5",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p5",
            targetPlayerId: "p2",
          },
        },
      },
      {
        sequenceNumber: 34,
        eventType: "action",
        userId: "p6",
        payload: {
          schemaVersion: 1,
          action: {
            type: "castVote",
            actorPlayerId: "p6",
            targetPlayerId: "p2",
          },
        },
      },
      {
        sequenceNumber: 35,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "resolveVote",
            actorPlayerId: "p1",
          },
        },
      },
      {
        sequenceNumber: 36,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p1",
            },
          },
        },
      },
      {
        sequenceNumber: 37,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p2",
            },
          },
        },
      },
      {
        sequenceNumber: 38,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p3",
            },
          },
        },
      },
      {
        sequenceNumber: 39,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p4",
            },
          },
        },
      },
      {
        sequenceNumber: 40,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p5",
            },
          },
        },
      },
      {
        sequenceNumber: 41,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "player",
              playerId: "p6",
            },
          },
        },
      },
      {
        sequenceNumber: 42,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "center",
              slotIndex: 0,
            },
          },
        },
      },
      {
        sequenceNumber: 43,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "center",
              slotIndex: 1,
            },
          },
        },
      },
      {
        sequenceNumber: 44,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "revealCard",
            actorPlayerId: "p1",
            target: {
              kind: "center",
              slotIndex: 2,
            },
          },
        },
      },
      {
        sequenceNumber: 45,
        eventType: "action",
        userId: "p1",
        payload: {
          schemaVersion: 1,
          action: {
            type: "completeRound",
            actorPlayerId: "p1",
          },
        },
      },
    ],
    notes: [
      "Deterministic self-play: every action was validated by the engine before being recorded.",
      "Hidden-info contract: the replay UI renders the masked observer projection by default; player perspectives and the recap toggle are explicit opt-ins.",
      "Final outcome: werewolf-eliminated.",
      "The doppelganger copies an immediate-action role and performs it inside her own night step (two submits).",
    ],
  },
};
